import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/applePay.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var generateApplePayPaymentSession = (_0) => __async(void 0, [_0], function* ({
  validationUrl,
  lang,
  email,
  event_id,
  is_mada
}) {
  try {
    const lan = getLocaleOnly(lang);
    const captcha = yield generateRecaptchaToken("apple_pay_session");
    const data = yield fetchClient({
      url: "/apple-pay/payment-session",
      options: {
        method: "POST",
        body: JSON.stringify({
          event_id,
          validation_url: validationUrl,
          is_mada,
          lang: lan,
          captcha
        })
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "generateApplePayPaymentSessionException",
      context: { tags: { journey: "checkout" }, extra: { email } }
    });
  }
});
var proceedApplePayPayment = (_0) => __async(void 0, [_0], function* ({
  order_id,
  payment_session_id,
  apple_pay_token,
  lang,
  email,
  amount_sar,
  is_mada
}) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const captcha = yield generateRecaptchaToken("apple_pay_proceed");
    const data = yield fetchClient({
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.paymentApi,
      url: "/apple-pay/payment-session/proceed",
      options: {
        method: "POST",
        body: JSON.stringify({
          order_id,
          payment_session_id,
          apple_pay_token,
          amount_sar,
          is_mada,
          lang: locale,
          captcha
        })
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "proceedApplePayPaymentException",
      context: { tags: { journey: "checkout" }, extra: { email } }
    });
  }
});

export {
  generateApplePayPaymentSession,
  proceedApplePayPayment
};
//# sourceMappingURL=chunk-TXVZA2CU.mjs.map